import type { FunctionComponent } from 'react'
import React, { useContext, useRef, useState } from 'react'

import { FormEntryPage } from '../../../../shared/pages/FormEntryPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { FormEntryInputRef, SingleInputState } from '../../../../shared/types/toolTypes'
import { cleanText } from '../../../../shared/utils/cleanText'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { isNotEmpty } from '../../../../shared/utils/isNotEmpty'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { ItemOrderedFlow, OrderNumberFlow } from '../../pageFlowData'
import { data } from './data'

export const ItemOrdered: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    order: { itemOrdered },
  } = state

  const [inputData, setInputData] = useState<SingleInputState>({
    renderError: false,
    value: '',
  })
  const itemOrderedInput = useRef<FormEntryInputRef>(null)

  const getValue = () => {
    return cleanText(itemOrderedInput?.current?.formEntryInput?.value || '')
  }

  const handleTracking = (value: string) => {
    const trackingAnswer = `question | ${ItemOrderedFlow.VIEW_NAME} | ${value}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = (value: string) => {
    dispatch({ type: 'UPDATE_STEP', data: OrderNumberFlow.STEP })
    dispatch({ type: 'UPDATE_ITEM_ORDERED', data: value })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: OrderNumberFlow.PROGRESS_VALUE })
  }

  const handleSubmit = () => {
    const value = getValue()
    const itemOrderedHasError = !isNotEmpty(value)

    setInputData({
      renderError: itemOrderedHasError,
      value: value,
    })

    if (!itemOrderedHasError) {
      handleTracking(value)
      handleDispatch(value)
    }
  }

  const { renderError, value: errorValue } = inputData
  const { imgObj, placeholderText, title } = data

  return (
    <FormEntryPage
      buttonText="Next"
      defaultValue={itemOrdered}
      fieldData={{
        renderError: renderError,
        value: errorValue,
      }}
      handleSubmit={handleSubmit}
      id="item-ordered"
      imgObj={imgObj}
      isFocused={true}
      placeholderText={placeholderText}
      ref={itemOrderedInput}
      testId="item-ordered"
      title={title}
    />
  )
}
